<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="活动标题" prop="title" :rules="[{ required: true, message: '请输入活动标题' }]">
      <el-input v-model="form.title" placeholder="请输入活动标题" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="活动地址" prop="address" :rules="[{ required: true, message: '请输入活动地址' }]">
      <el-input v-model="form.address" placeholder="请输入活动地址" class="max-w460"></el-input>
    </el-form-item>


    <!-- 全分类选择 -->
    <el-form-item label="活动分类" prop="name" >
      <div>{{ form.categorya.name }}</div>
    
      <el-button @click="chooseCategory" icon="el-icon-plus">选择分类</el-button>
    </el-form-item>

    
    <el-form-item label="参与人员最大人数" prop="iden_num" >
      <el-input v-model="form.iden_num" placeholder="请输入参与人员最大人数" class="max-w460"></el-input>
    </el-form-item>



    <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas>

    <el-form-item label="活动广告" prop="image_id" :rules="rulesImage">
      <div class="d-c-c ad-picture" @click="openUpload">
        <img v-if="form.imgUrl" :src="form.imgUrl" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x310</p>
    </el-form-item>


    <el-form-item label="活动时间段" prop="time_bucket" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="add">添加时间段</el-button>
           </div>

           <table v-if="form.time_bucket" border cellspacing="0" class="mt10" >
             <tr>
               <th class="w150">开启日期</th>
               <th class="w150">结束日期</th>
               <th class="w250">操作</th>
             </tr>
             <tr v-for="(item,index) in form.time_bucket">
               <td class="tc">
                  <el-date-picker
                    v-model="item.start_time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
              </td>
               <td class="tc">
                  <el-date-picker
                    v-model="item.end_time"
                    align="right"
                    type="date"
                    placeholder="选择日期"
                    format="yyyy-MM-dd" 
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </td>
               <td class="tc" style="width: 100px;"><a @click="del(item.id)"> 删除</a></td>
             </tr>
           </table>
     
    </el-form-item>
    

     <el-form-item label="活动副标题">
      <div class="edit_container">
        <Uediter :id="ue2"  :text2="form.subtitle" :config="ueditor2.config" 
        ref="ue2" @contentChange2="contentChangeFuncSubtitle"></Uediter>
      </div>
    </el-form-item>

    <el-form-item label="活动内容">
      <div class="edit_container" >
        <Uediter :id="ue1"  :text1="form.content" :config="ueditor.config" ref="ue1" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>


    <el-form-item label="活动行程">
      <div class="edit_container">
        <Uediter :id="ue3"  :text3="form.route" :config="ueditor3.config" 
        ref="ue3" @contentChange3="contentChangeFuncRoute"></Uediter>
      </div>
    </el-form-item>

    <el-form-item label="活动须知">
      <div class="edit_container">
        <Uediter :id="ue4"  :text4="form.notice" :config="ueditor4.config" 
        ref="ue4" @contentChange4="contentChangeFuncNotice"></Uediter>
      </div>
    </el-form-item>

     <!--上传图片组件-->
     <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>

<!-- 
    <el-form-item label="是否提交资料" >
      <el-radio-group v-model="form.is_data" >
          <el-radio  :label="0">否</el-radio>
          <el-radio  :label="1">是</el-radio>
        </el-radio-group>
    </el-form-item> -->

    <el-form-item label="是否免费">

      <el-radio-group v-model="form.is_free">
          <el-radio  :label="1">免费</el-radio>
          <el-radio  :label="0">收费</el-radio>
        </el-radio-group>  
    </el-form-item>

    <el-form-item label="价格" prop="price" v-if="form.is_free==0">
      <el-input type="number"  v-model="form.price" placeholder="请输入活动价格" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="请选择退款比例" prop="iden_num" v-if="form.is_free == 0">
      <el-radio-group v-model="form.refund_type">
          <el-radio  :label="1" >比例</el-radio>
          <el-radio  :label="2">固定金额</el-radio>
          <el-radio  :label="3">后台输入</el-radio>
      </el-radio-group>
    </el-form-item>


    <el-form-item label="退款金额" prop="iden_num" v-if="form.is_free == 0 && form.refund_type != 3">
      <el-input v-if="form.refund_type == '1'" v-model="form.refund" placeholder="请输入退款比例" class="max-w460"></el-input>
      <span v-if="form.refund_type == '1'">%</span>
      <el-input v-if="form.refund_type == '2'" v-model="form.refund" placeholder="请输入退款金额" class="max-w460"></el-input>
      <span v-if="form.refund_type == '2'">元</span>

      <div v-if="form.refund_type == '1'">退款金额：{{ (form.refund/100 * form.price).toFixed(2) }}元</div>
      <div v-if="form.refund_type == '2'">退款金额：{{ form.refund }}元</div>
    </el-form-item>

  </div>
</template>

<script>

import Uediter from '@/components/UE1.vue';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
export default {
  components: {
    Uediter,
    Categoryas,
    Upload
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传活动图'));
      } else {
        callback();
      }
    };
    return {
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      isupload:false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传活动广告图片', trigger: 'change' }],
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        },
      },
      ueditor2: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor3: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor4: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ue1:"ue1",
      ue2:"ue2",
      ue3:"ue3",
      ue4:"ue4",
      iscategorya:false,
      excludeIds:[],
     

    };
  },
  props: ['form','editType'],
  methods: {
    del(id){
      var arr = [];
      console.log(id)
      this.form.time_bucket.forEach(function(res){
        if(res.id != id){
          arr.push(res)
        }
      })
      this.form.time_bucket = arr
    },
    add(){
      console.log(this.form)
      this.form.time_bucket.push({
        id:  (Math.floor(Math.random() * 99999) + 1)+"_"+ (Math.floor(Math.random() * 1000) + 1)+"_"+ (Math.floor(Math.random() * 10) + 1),
        start_time:"",
        end_time:"",
      });
      console.log('this.form.time_bucket',this.form.time_bucket);
    },
    chooseCategory(){
      this.iscategorya = true;
    },
     /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.content=e;
    },
    contentChangeFuncSubtitle(e){
      this.form.subtitle = e;
    },
    contentChangeFuncRoute(e){
      this.form.route = e;
    },
    contentChangeFuncNotice(e){
      this.form.notice = e;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.imgUrl = e[0].file_path;

      }
      this.isupload = false;
    },
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.iscategorya = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          arr = {
            name: item.name,
            categorya_id: item.categorya_id,
            image: item.image,
          };
        }
        self.form.categorya = arr;
    
      }
    },
  

  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/part/Basic.vue